const RESOURCE_NAME = "entities/questionnaires";

export default {};
